// ENHANCEMENT: sum function - takes arr of nodes, attr to sum

export default function(nodes) {
  let height = 0;
  nodes.forEach( el => { if (el) height += el.offsetHeight } );
  return height;
}
